import {FkoInitialParams} from '@/redux/slices/fkoFormData';
import {generateUuid} from '@/utils/uuid';

type FkoParamsStorage = FkoInitialParams & {
  paramsId: string;
};

export const getFkoInitialParamsLocalstorage = ({
  paramsId,
  sport,
}: {
  paramsId?: string;
  sport?: string | null;
}): FkoInitialParams | undefined => {
  const progress: FkoParamsStorage = JSON.parse(localStorage.getItem('fko_initial') ?? 'null');

  return paramsId === progress?.paramsId && sport === progress?.sport ? progress : undefined;
};

export const setFkoInitialParamsLocalstorage = (progress: FkoInitialParams) => {
  const paramsId = generateUuid();
  const paramsToSave: FkoParamsStorage = {...progress, paramsId};

  localStorage.setItem('fko_initial', JSON.stringify(paramsToSave));
  return {paramsId};
};
